export const LIST_ADMINUSERS_REQUESTED = 'LIST_ADMINUSERS_REQUESTED';
export const LIST_ADMINUSERS_COMPLETED = 'LIST_ADMINUSERS_COMPLETED';
export const LIST_ADMINUSERS_FAILED = 'LIST_ADMINUSERS_FAILED';
